import type { RoomsParticipantDistributionStore } from './store'
import { useDependencies } from '@/scopes/common/infrastructure/dependencies'

import { identity } from 'ramda'
import { useStore } from 'zustand'

export function useRoomsParticipantsDistributionStore() {
  const { roomsParticipantsDistributionStore } = useDependencies()
  return useStore(roomsParticipantsDistributionStore, identity<RoomsParticipantDistributionStore>)
}
